import { jsx as o, jsxs as Y } from "react/jsx-runtime";
import { forwardRef as Z, useRef as oo, useState as l, useEffect as to } from "react";
import e from "classnames";
import no from "sanitize-html";
import eo from "../FieldContainer/index.js";
import ao from "../ContentEditable/index.js";
import "../../components/Breadcrumbs/index.js";
import io from "../../components/Button/index.js";
import "reactjs-popup";
import "../../components/ThemeContext/index.js";
import "../../modal-l0sNRNKZ.js";
import co from "../../helpers/nanoid.js";
import "react-i18next";
import "../Input/index.js";
import "../../components/Tooltip/index.js";
const so = "forma-ui__wysiwyg__container", ro = "forma-ui__wysiwyg__fieldContainer", lo = "forma-ui__wysiwyg__withIcon", mo = "forma-ui__wysiwyg__input", uo = "forma-ui__wysiwyg__readonly", _o = "forma-ui__wysiwyg__secondary", ho = "forma-ui__wysiwyg__label", fo = "forma-ui__wysiwyg__total", wo = "forma-ui__wysiwyg__button", yo = "forma-ui__wysiwyg__toolbar", po = "forma-ui__wysiwyg__toolbarButton", Co = "forma-ui__wysiwyg__active", vo = "forma-ui__wysiwyg__toolbarButtonIcon", n = {
  container: so,
  fieldContainer: ro,
  withIcon: lo,
  input: mo,
  readonly: uo,
  secondary: _o,
  label: ho,
  total: fo,
  button: wo,
  toolbar: yo,
  toolbarButton: po,
  active: Co,
  toolbarButtonIcon: vo
}, bo = 300, g = [
  {
    name: "bold",
    icon: /* @__PURE__ */ o("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ o("path", { d: "M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z" }) }),
    onClick: () => document.execCommand("bold", !1)
  },
  {
    name: "italic",
    icon: /* @__PURE__ */ o("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ o("path", { d: "m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z" }) }),
    onClick: () => document.execCommand("italic", !1)
  },
  {
    name: "underline",
    icon: /* @__PURE__ */ o("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ o("path", { d: "M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8 1.9 0 3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4z" }) }),
    onClick: () => document.execCommand("underline", !1)
  },
  {
    name: "insertUnorderedList",
    icon: /* @__PURE__ */ o("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ o("path", { d: "M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z" }) }),
    onClick: () => document.execCommand("insertUnorderedList", !1)
  },
  {
    name: "insertOrderedList",
    icon: /* @__PURE__ */ o("svg", { viewBox: "0 0 20 20", children: /* @__PURE__ */ o("path", { d: "M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z" }) }),
    onClick: () => document.execCommand("insertOrderedList", !1)
  }
], jo = Z(({
  id: m = co(8),
  name: B,
  onChange: d,
  onFocus: u,
  onBlur: _,
  hidden: z,
  fullWidth: x,
  label: S,
  className: H,
  value: c,
  readOnly: h,
  viewStyle: I = "primary",
  showIconAlways: k,
  containerClass: M,
  labelClass: V,
  error: f,
  errorMessage: N,
  success: T,
  icon: w,
  buttons: y,
  showClearButton: s,
  tooltip: U,
  tooltipClass: L,
  placeholder: R,
  notice: E,
  required: j,
  minLength: A,
  maxLength: F
}, go) => {
  const r = oo(null), [a, p] = l(!1), [K, C] = l(!1), [O, W] = l([]);
  to(() => {
    document.execCommand("styleWithCSS", !0);
  }, []);
  const i = () => {
    W(g.filter(({ name: t }) => document.queryCommandState(t)).map(({ name: t }) => t));
  }, q = (t) => {
    d && d({ target: { name: B, value: t } });
  }, $ = (t) => {
    u && u(t), p(!0), C(!0), i();
  }, D = (t) => {
    _ && _(t), C(!1), setTimeout(() => p(!1), bo);
  }, G = () => {
    i();
  }, J = () => {
    i();
  }, P = a && s && !!c && !!no(c, { allowedTags: [] });
  return /* @__PURE__ */ o(
    eo,
    {
      id: m,
      hidden: z,
      required: j,
      fullWidth: x,
      containerClass: e(M, n.fieldContainer),
      labelClass: e(V, n.label),
      label: S,
      error: f,
      errorMessage: N,
      showClearButton: s,
      notice: E,
      buttons: y,
      icon: w,
      tooltip: U,
      tooltipClass: L,
      isShowClear: P,
      isShowButtons: a,
      isShowTooltip: K,
      isShowIcon: a || k,
      children: /* @__PURE__ */ Y("div", { className: e(n.container, H, a && n.withButtons), children: [
        /* @__PURE__ */ o("div", { className: n.toolbar, children: g.map(({ name: t, icon: Q, onClick: X }) => /* @__PURE__ */ o(
          io,
          {
            viewStyle: "secondary",
            className: e(n.toolbarButton, O.includes(t) && n.active),
            size: "extraSmall",
            iconClassName: n.toolbarButtonIcon,
            icon: Q,
            onClick: () => {
              var v, b;
              (v = r.current) == null || v.focus(), X(), i(), (b = r.current) == null || b.focus();
            }
          },
          t
        )) }),
        /* @__PURE__ */ o(
          ao,
          {
            id: m,
            className: e(
              n.input,
              n[I],
              (w || y || s) && n.withIcon,
              f && "error",
              T && "success",
              h && n.readonly
            ),
            readOnly: h,
            minLength: A,
            maxLength: F,
            placeholder: R,
            onKeyUp: J,
            onClick: G,
            onChange: q,
            onFocus: $,
            onBlur: D,
            value: c,
            ref: r
          }
        )
      ] })
    }
  );
});
export {
  jo as default
};
